export const keys = {
  buttons: {
    home: 'Go home',
    languageToggle: 'Fr',
  },
  ui: {
    navigation: {
      back: 'Back',
      next: 'Next',
      cancel: 'Cancel',
    },
    navbar: {
      referral: 'Earn ${{0}}',
      tooltip: {
        referral: 'Earn ${{0}}',
        notifications: 'Notifications',
        helpMenu: 'Help Menu',
        userMenu: 'User Menu',
      },
      menu: {
        policies: 'My Policies',
        profile: 'Profile',
        logout: 'Logout',
        helpCenter: 'Help Center',
        contactUs: 'Contact Us',
      },
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
